import { render, staticRenderFns } from "./BeCardReview.vue?vue&type=template&id=1d3eca18&scoped=true"
import script from "./BeCardReview.vue?vue&type=script&lang=js"
export * from "./BeCardReview.vue?vue&type=script&lang=js"
import style0 from "./BeCardReview.vue?vue&type=style&index=0&id=1d3eca18&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3eca18",
  null
  
)

export default component.exports